import React, { useCallback } from 'react';
import { DrawingManager } from '@react-google-maps/api';
import {
	setEditablePolygons,
	setIsDrawEnabled,
	setIsSelectedPolygonEditable,
	setIsSelectedPolygonSaved,
	setSelectedPolygonIndex,
	setSelectedPolygonValidationStatus,
} from 'reducers/awdView.reducer';
import { PolygonValidationStatus } from 'interfaces/awd.interface';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { EditablePolygon } from 'interfaces/maps.interface';

type DrawingModeProps = {
	validateSelectedPolygon: (
		a: google.maps.Polygon,
		b: number,
	) => PolygonValidationStatus;
};

const DrawingMode: React.FC<DrawingModeProps> = ({
	validateSelectedPolygon,
}): JSX.Element => {
	const dispatch = useAppDispatch();
	const selectedPoint = useAppSelector((s) => s.awdView.selectedPoint);
	const editablePolygons = useAppSelector((s) => s.awdView.editablePolygons);

	const onPolygonComplete = useCallback(
		(polygon: google.maps.Polygon) => {
			const polygons = JSON.parse(JSON.stringify(editablePolygons));
			const totalPolygonsCount = Object.keys(polygons).length;
			const newPolygonPath = polygon
				.getPath()
				.getArray()
				.map((coord: any) => {
					return {
						lat: coord.lat(),
						lng: coord.lng(),
					};
				});
			let temp: EditablePolygon = {
				polygonApprovalStatus: 'GEOFENCING_PENDING',
				isPolygonLocked: 'UNBLOCKED',
				geometry: newPolygonPath,
				placeId: undefined,
				parentPointSignatures: [`${selectedPoint}`],
			};
			polygons[totalPolygonsCount] = temp;
			polygon.setMap(null);
			dispatch(setEditablePolygons({ ...polygons }));
			dispatch(
				setSelectedPolygonValidationStatus(
					validateSelectedPolygon(polygon, totalPolygonsCount),
				),
			);
			dispatch(setIsSelectedPolygonSaved(false));
			dispatch(setSelectedPolygonIndex(totalPolygonsCount));
			dispatch(setIsSelectedPolygonEditable(true));
			dispatch(setIsDrawEnabled(false));
		},
		[dispatch, editablePolygons, selectedPoint, validateSelectedPolygon],
	);

	return (
		<DrawingManager
			onPolygonComplete={(e) => onPolygonComplete(e)}
			options={{
				drawingControl: false,
				drawingMode: google.maps.drawing.OverlayType.POLYGON,
				drawingControlOptions: {
					drawingModes: [
						// google.maps.drawing.OverlayType.POLYGON,
						// google.maps.drawing.OverlayType.POLYLINE,
						// google.maps.drawing.OverlayType.MARKER,
						// google.maps.drawing.OverlayType.RECTANGLE,
					],
				},
			}}
		/>
	);
};

export default React.memo(DrawingMode);
